module.exports = __webpack_public_path__ + "img/gaiadaily-scode.5f5fdeaa.jpg";